import React from 'react';
import './../css/Ondersteuningsvormen.css';
import './../css/Hero.css';

import img1 from './../img/img1.webp';
import img2 from './../img/img2.webp';
import img3 from './../img/img3.webp';

function Ondersteuningsvormen() {

    return (
        <div id="ondersteuningsvormen" className="Ondersteuningsvormen section fade-in">
            <div className="section-wrapper ">
                <div className="section-title">
                    Hulp en begeleiding afgestemd op uw vraag
                </div>
                <div className="section-bio">
                    Als specialist in autisme en sensorische verwerking bied ik zowel psycho-educatie, scholing als persoonlijke ondersteuning aan. Of u nu op zoek bent naar praktische informatie voor uzelf, uw organisatie, of uw kind, ik help u verder met op maat gemaakte oplossingen die aansluiten bij uw specifieke situatie.                </div>
            </div>
            <div className="items-wrapper">
                <div className="wrapper-item ">
                    <div className="item-text">
                        <span>Psycho-educatie & scholing</span>
                        <div>
                            <br></br>
                            Heeft u als organisatie, of als ouder/begeleider behoefte aan meer uitleg over de problemen
                            waar
                            u in de dagelijkse praktijk tegenaan loopt, vult u dan uw vraag en uw gegevens in bij het
                            contact formulier. Ik neem dan contact met u op vrijblijvend de mogelijkheden die ik u kan
                            bieden door te nemen.
                            <br></br><br></br>
                            Het scholingsaanbod kan op maat gemaakt worden naar doelgroep en problematiek en
                            persoonlijke
                            behoefte.
                            <br></br><br></br>
                            Ik bied interactieve workshops aan, maar ook meer educatie gericht op de onderliggende
                            theorieën van ontwikkeling, Autisme en Sensorische Informatieverwerking.
                            <br></br><br></br>
                            Een combinatie van theorie en ervaringsleren is ook mogelijk. Ik pas mij graag aan naar de
                            behoefte van u als persoon of organisatie om het maximale uit een training te kunnen halen.
                        </div>
                    </div>
                    <div className="section-img">
                        <img src={img1} alt="main cover" loading="eager"/>
                    </div>
                </div>
                <div className="wrapper-item ">
                    <div className="item-text">
                        <span>Persoonlijke ondersteuning</span>
                        <div>
                            <br></br>
                            Ontdekken dat u of uw kind autisme heeft, brengt vaak veel vragen met zich mee. Ik help u
                            bij het vinden van houvast in een maatschappij die nog niet altijd even autismevriendelijk
                            is.
                            <br></br><br></br>
                            We onderzoeken samen welke aanpassingen helpend zijn en hoe u grip kunt krijgen op situaties
                            die moeilijk verlopen thuis, op school of in de vrije tijd.
                        </div>
                    </div>
                    <div className="section-img">
                        <img src={img2} alt="main cover" loading="eager"/>
                    </div>
                </div>
                <div className="wrapper-item ">
                    <div className="item-text">
                        <span>Ondersteuningsprofielen & diagnostiek</span>
                        <div>
                            <br></br>
                            Indien u een vermoeden heeft dat u of uw kind zich anders ontwikkelt kan ik met u kijken
                            naar de mogelijkheden voor diagnostiek. Aan welke ondersteuningsbehoefte kan ik voldoen door
                            het doen van diagnostiek.
                            <br></br><br></br>
                            Ik kan daarbij ondersteunen door het opstellen van een sensorisch profiel, Autisme onderzoek
                            of intelligentie onderzoek. Vanuit dit stukje diagnostiek kan ik verder in kaart brengen aan
                            welke ondersteuningsbehoefte op het gebied van Autisme, verstoorde prikkelverwerking of
                            mogelijke verstandelijke beperking ik kan voldoen.
                        </div>
                    </div>
                    <div className="section-img">
                        <img src={img3} alt="main cover" loading="eager"/>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Ondersteuningsvormen;
